import { combineReducers } from 'redux'
import editImprove from './editImprove'
import improves from './improves'

const improvesReducer = combineReducers({ editImprove, improves })

export default improvesReducer
